export const en = {
  translation: {
    common: {
      loading: 'Loading...',
      error: 'Error',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      retry: 'Retry',
      actions: {
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
      },
    },
    error: {
      network: 'Network error',
      unauthorized: 'Unauthorized',
    },
    errors: {
      something_wrong: 'Something went wrong',
      reload: 'Reload page',
      support_id: 'Support ID: {{id}}',
      not_found: 'Page not found.',
      forbidden: 'Access denied.',
      server_error: 'Server error. Please try again later.',
      go_home: 'Go home',
    },
    autoUpdate: {
      title: 'Update available',
      countdown: 'Reloading in {{n}}',
    },
    nav: {
      dashboard: 'Dashboard',
      projects: 'Projects',
      data: 'Data',
      quickTasks: 'Quick Tasks',
      voices: 'Voices',
      overlay: 'Overlay',
      transcription: 'Transcription',
      translate: 'Translate',
      templates: 'Templates',
      stats: 'Stats',
      settings: 'Settings',
      notifications: 'Notifications',
      admin: 'Admin',
    },
    test: {
      greeting: 'Hi',
      welcome: 'Hi, {{name}}',
    },
    notif: {
      task_done: 'Task {{taskId}} done',
    },
  },
}
